<template>
  <span v-if="user" class="mini-user-display">
    <img class="mini-user-profile-image" :src="user.profile_image_url" />
    <span class="mini-user-name">{{user.display_name}}</span>
  </span>
</template>

<script>
export default {
  name: 'User',
  props: ['user_id'],
  async created () {
    // console.log('FETCHING', this.user_id)
    this.fetched = true
    this.$store.dispatch('fetchUser', this.user_id)
  },
  data () {
    return {
      users: this.$store.state.users,
      fetched: false
    }
  },
  computed: {
    user () {
      return this.users[this.user_id.toLowerCase()]
    }
  }
}
</script>

<style scoped>
.mini-user-profile-image {
  width: 25px;
  min-height: 25px;
  float: left;
  position: absolute;
  padding-left: 5px;
}

.mini-user-name {
  margin-left: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue